import React from 'react';
import styled from 'styled-components';

import { Fill } from 'layout-core-components';
import { Heading, Text } from 'primitive-components';

const Centered = styled.div`
  display: grid;
  justify-content: center;
  align-content: center;
`;

const ContentLayout = styled.div`
  display: grid;
  justify-items: center;
  text-align: center;
  padding: 0 64px;
`;

const StyledHeading = styled(Heading)`
  margin-bottom: 10px;
`;

export default function ReportsSegmentCategoryZeroState() {
  return (
    <Fill to="parent">
      <Centered>
        <ContentLayout>
          <StyledHeading size={3}>No tags in that group or date range</StyledHeading>
          <Text styleType="light">
            Apply tags to individual transactions for tagging info within this date range.
          </Text>
        </ContentLayout>
      </Centered>
    </Fill>
  );
}
